import { useContext } from 'react';
import { CustomSIPHeaderFormContext } from '../context/CustomSIPHeaderFormContext.jsx';

export const useCustomSIPHeaderForm = () => {
    const context = useContext(CustomSIPHeaderFormContext);
    if (!context) {
        throw new Error(
            'useCustomSIPHeaderForm must be used within a CustomSIPHeaderFormProvider',
        );
    }
    return context;
};
